import { QueryKey, useQuery } from "react-query";
import { getInspection } from "../../api/inspections/getInspection";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

export default function useInspection({
  id,
  enabled = true,
  previousItemStatus,
}: {
  id: number | string;
  enabled?: boolean;
  previousItemStatus?: "passed" | "failed" | "incomplete";
}) {
  const queryKey = getInspectionQueryKey(id, previousItemStatus);

  const networkHeaders = useNetworkHeaders();
  const inspectionQuery = useQuery(queryKey, getInspection(networkHeaders), { enabled: id !== undefined && enabled });

  return { inspectionQuery, queryKey };
}

export function getInspectionQueryKey(
  id: number | string,
  previousItemStatus?: "passed" | "failed" | "incomplete",
): QueryKey {
  return ["inspection", id.toString(), previousItemStatus].filter((key) => key);
}
